export interface ILinkReferralAccount {
  senderFirstName: string;
}

export interface ILinkReferralAccountApi {
  senderFirstName: string;
}

export enum ReferralStatus {
  Paid = 'paid',
  NotPaid = 'not paid',
}

export interface IReferrer {
  id: string;
  name: string;
  status: ReferralStatus;
}

export interface IGetReferrerResponse {
  referrer: IReferrer | null;
}

/** The portal always claims as `web`; mobile sends `ios | android`. */
export type TReferralClaimPlatform = 'web';

/**
 * The claim body (GOTU-7141). No outcome field: the server assigns `recorded`,
 * `invalid_code` or `legacy_link` in the same statement that inserts the row,
 * and the client neither sends nor infers one.
 */
export interface IReferralClaimPayload {
  code: string;
  identifier: string;
  platform: TReferralClaimPlatform;
}

/**
 * The three states `GET /referrals/claims?code=` answers with (GOTU-7243),
 * plus the one the client assigns when it never got an answer at all.
 *
 * `unavailable` is the enumeration breaker tripping — it means "we cannot
 * confirm the referrer right now", NOT "this code is invalid". Rendering the
 * invalid-code error for it invites the user to delete a correct code, which is
 * the attribution loss the design exists to prevent.
 *
 * `server_error` is never on the wire: `lookupReferrerByCode` returns it when
 * the request itself failed. The two used to collapse into `unavailable`, which
 * made a 5xx and a deliberate decline indistinguishable in the funnel — one is
 * an outage to fix, the other is the breaker working as designed (GOTU-8354).
 * They behave identically at the gate: both allow sign-up.
 */
export type TReferralLookupStatus = 'ok' | 'no_match' | 'unavailable' | 'server_error';

export interface IReferralLookupResponse {
  status: TReferralLookupStatus;
  /** First name plus surname initial, e.g. `Adam A.`. Present only on `ok`. */
  display?: string;
}
